import * as sbaIcons from './sba-icons.json';

export const sbaIconSet = sbaIcons.data;

export type SbaIcon = keyof typeof sbaIconSet;
